import {Permissions} from "./config";

export const permissions = Object.freeze([

    //Article
    {
        label: 'Artigos',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
        permissions: {
            articleView: { value: Permissions.ARTICLE_VIEW, has: false, },
            articleAdd: { value: Permissions.ARTICLE_ADD, has: true, },
            articleEdit: { value: Permissions.ARTICLE_UPDATE, has: false, },
            articleRemove: { value: Permissions.ARTICLE_DELETE, has: false, },
        },
    },

    //User
    {
        label: 'Funcionários',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover', 'Alterar senha'],
        permissions: {
            userView: { value: Permissions.USER_VIEW, has: false },
            userAdd: { value: Permissions.USER_ADD, has: false },
            userEdit: { value: Permissions.USER_UPDATE, has: false },
            userRemove: { value: Permissions.USER_DELETE, has: false },
            userChangePass: { value: Permissions.USER_CHANGE_PASS, has: false },
        },
    },

    //Client
    {
        label: 'Clientes',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
        permissions: {
            clientView: { value: Permissions.CLIENT_VIEW, has: false },
            clientAdd: { value: Permissions.CLIENT_ADD, has: false },
            clientEdit: { value: Permissions.CLIENT_UPDATE, has: false },
            clientRemove: { value: Permissions.CLIENT_DELETE, has: false },
        },
    },

    //Provider
    {
        label: 'Fornecedores',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
        permissions: {
            providerView: { value: Permissions.PROVIDER_VIEW, has: false },
            providerAdd: { value: Permissions.PROVIDER_ADD, has: false },
            providerEdit: { value: Permissions.PROVIDER_UPDATE, has: false },
            providerRemove: { value: Permissions.PROVIDER_DELETE, has: false },
        },
    },

    //Sells
    {
        label: 'Vendas',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
        permissions: {
            sellView: { value: Permissions.SELL_VIEW, has: false },
            sellAdd: { value: Permissions.SELL_ADD, has: false },
            // sellEdit: { value: Permissions.SELL_UPDATE, has: false },
            // sellRemove: { value: Permissions.SELL_DELETE, has: false },
        },
    },

    //Purchase
    {
        label: 'Compras',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
        permissions: {
            purchaseView: { value: Permissions.PURCHASE_VIEW, has: false },
            purchaseAdd: { value: Permissions.PURCHASE_ADD, has: false },
            // purchaseEdit: { value: Permissions.PURCHASE_UPDATE, has: false },
            // purchaseRemove: { value: Permissions.PURCHASE_DELETE, has: false },
        },
    },

    //Budget
    {
        label: 'Orçamentos',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
        permissions: {
            sellView: { value: Permissions.BUDGET_VIEW, has: false },
            sellAdd: { value: Permissions.BUDGET_ADD, has: false },
            // sellEdit: { value: Permissions.BUDGET_UPDATE, has: false },
            // sellRemove: { value: Permissions.BUDGET_DELETE, has: false },
        },
    },

    //Receipt and others
    {
        label: 'Faturas',
        checkBoxlabels: ['Pagamento', 'Remover Recibo', 'Nota de Débito', 'Nota de Crédito'],
        permissions: {
            invoicePayment: { value: Permissions.INVOICE_PAYMENT, has: false },
            invoiceReceiptDelete: { value: Permissions.INVOICE_RECEIPT_DELETE, has: false },
            invoiceNotaDebito: { value: Permissions.INVOICE_NOTA_DEBITO, has: false },
            invoiceNotaCredito: { value: Permissions.INVOICE_NOTA_CREDITO, has: false },
        },
    },

    //Stock
    {
        label: 'Stock',
        checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
        permissions: {
            stockView: { value: Permissions.STOCK_VIEW, has: false },
            stockAdd: { value: Permissions.STOCK_ADD, has: false },
            // stockEdit: { value: Permissions.STOCK_UPDATE, has: false },
            // stockRemove: { value: Permissions.STOCK_DELETE, has: false },
        },
    },

    //Cash Flow
    // {
    //     label: 'Fluxo de caixa',
    //     checkBoxlabels: ['Visualizar', 'Adicionar', 'Editar', 'Remover'],
    //     permissions: {
    //         stockView: { value: Permissions.CASH_FLOW_VIEW, has: false },
    //         stockAdd: { value: Permissions.CASH_FLOW_ADD, has: false },
    //         // stockEdit: { value: Permissions.STOCK_UPDATE, has: false },
    //         // stockRemove: { value: Permissions.STOCK_DELETE, has: false },
    //     },
    // },
]);